export default {
  props: {
    label: 'Textarea'
  },
  withLabel: {},
  withoutLabel: {
    label: undefined
  }
};
